import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRightLeft, Wallet, Building2, Briefcase, Landmark, ShieldCheck } from 'lucide-react';

export default function ServicesPage() {
  const { t } = useLanguage();
  const services = t('landing.services') || [];
  const icons = [Wallet, ArrowRightLeft, Building2, Briefcase, Landmark, ShieldCheck];
  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-xs uppercase tracking-widest text-[hsl(var(--brand-gold))]">Services</div>
      <h1 className="font-serif text-4xl sm:text-5xl mt-2 text-[hsl(var(--brand-navy-2))]">{t('services.title')}</h1>
      <p className="mt-4 text-lg text-[hsl(var(--muted-foreground))] max-w-2xl">{t('services.subtitle')}</p>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
        {services.map((s, i) => {
          const Icon = icons[i] || Wallet;
          return (
            <Card key={i} className="bg-white">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 rounded-xl bg-[hsl(var(--brand-gold))]/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="h-6 w-6 text-[hsl(var(--brand-navy))]" />
                  </div>
                  <div>
                    <div className="font-serif text-xl text-[hsl(var(--brand-navy-2))]">{s.title}</div>
                    <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))] leading-6">{s.body}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
